import type { ETLTaskChainResponse } from '@/model/etlTasks/dto.generated';
import { useRefreshUser } from '@/viewmodel/features/user';
import { useEffect, useRef } from 'react';

export function useGoldChainUserRefresh(chains: ETLTaskChainResponse[] | undefined): void {
  const refreshUser = useRefreshUser();
  const seenGoldChainsRef = useRef<Set<string>>(new Set());
  const goldInitializedRef = useRef(false);

  useEffect(() => {
    if (chains === undefined) return;

    const terminalGold = chains.filter((c) => c.kind === 'gold' && c.status === 'SUCCESS');

    if (!goldInitializedRef.current) {
      for (const chain of terminalGold) {
        if (chain.id) seenGoldChainsRef.current.add(chain.id);
      }
      goldInitializedRef.current = true;
      return;
    }

    for (const chain of terminalGold) {
      if (!chain.id || seenGoldChainsRef.current.has(chain.id)) continue;
      seenGoldChainsRef.current.add(chain.id);
      void refreshUser();
      break;
    }
  }, [chains, refreshUser]);
}
